/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../../libs/graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type RouteBuilderHeatmapDataQueryVariables = Types.Exact<{
  metroId: Types.Scalars['Int']['input']
  heatmapType: Types.HeatmapType
  filters?: Types.InputMaybe<Types.HeatmapFilterInput>
}>

export type RouteBuilderHeatmapDataQuery = {
  __typename?: 'Query'
  heatmapData: {
    __typename?: 'HeatmapData'
    pce: Array<{
      __typename?: 'PceHeatmapDataPoint'
      eventType: string
      mission: string
      sessionId: string
      timestampMs: number
      vehicleId: string
      softwareVersion: string
      annotationCount: number
      location: {
        __typename?: 'Geolocation'
        latitude: number
        longitude: number
      } | null
    }>
    disengagements: Array<{
      __typename?: 'DisengagementHeatmapDataPoint'
      initiator: string
      disengagementReason: string
      timestampMs: number
      softwareVersion: string
      location: {
        __typename?: 'Geolocation'
        latitude: number
        longitude: number
      } | null
    }>
    geonetCoverage: Array<{
      __typename?: 'GeonetCoverageHeatmapDataPoint'
      swVersion: string
      metroLocation: string
      avgDuration: number
      maxSpeedKmh: number
      streetName: string
      osmEdgeCount: number
      osmEdgeId: number
      successRate: number
      geojsonGeometry: string
    }>
  }
}

export type RouteBuilderHeatmapFiltersQueryVariables = Types.Exact<{
  metroId: Types.Scalars['Int']['input']
  heatmapType: Types.HeatmapType
}>

export type RouteBuilderHeatmapFiltersQuery = {
  __typename?: 'Query'
  heatmapFilters: {
    __typename?: 'HeatmapFilters'
    eventTypes: Array<string>
    initiators: Array<string>
    disengagementReasons: Array<string>
    softwareVersions: Array<string>
    earliestTimestampMs: number | null
    latestTimestampMs: number | null
  }
}

export const RouteBuilderHeatmapDataDocument = gql`
    query RouteBuilderHeatmapData($metroId: Int!, $heatmapType: HeatmapType!, $filters: HeatmapFilterInput) {
  heatmapData(metroId: $metroId, heatmapType: $heatmapType, filters: $filters) {
    pce {
      location {
        latitude
        longitude
      }
      eventType
      mission
      sessionId
      timestampMs
      vehicleId
      softwareVersion
      annotationCount
    }
    disengagements {
      location {
        latitude
        longitude
      }
      initiator
      disengagementReason
      timestampMs
      softwareVersion
    }
    geonetCoverage {
      swVersion
      metroLocation
      avgDuration
      maxSpeedKmh
      streetName
      osmEdgeCount
      osmEdgeId
      successRate
      geojsonGeometry
    }
  }
}
    `

/**
 * __useRouteBuilderHeatmapDataQuery__
 *
 * To run a query within a React component, call `useRouteBuilderHeatmapDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderHeatmapDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderHeatmapDataQuery({
 *   variables: {
 *      metroId: // value for 'metroId'
 *      heatmapType: // value for 'heatmapType'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRouteBuilderHeatmapDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteBuilderHeatmapDataQuery,
    RouteBuilderHeatmapDataQueryVariables
  > &
    (
      | { variables: RouteBuilderHeatmapDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderHeatmapDataQuery,
    RouteBuilderHeatmapDataQueryVariables
  >(RouteBuilderHeatmapDataDocument, options)
}
export function useRouteBuilderHeatmapDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderHeatmapDataQuery,
    RouteBuilderHeatmapDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderHeatmapDataQuery,
    RouteBuilderHeatmapDataQueryVariables
  >(RouteBuilderHeatmapDataDocument, options)
}
// @ts-ignore
export function useRouteBuilderHeatmapDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderHeatmapDataQuery,
    RouteBuilderHeatmapDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderHeatmapDataQuery,
  RouteBuilderHeatmapDataQueryVariables
>
export function useRouteBuilderHeatmapDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderHeatmapDataQuery,
        RouteBuilderHeatmapDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderHeatmapDataQuery | undefined,
  RouteBuilderHeatmapDataQueryVariables
>
export function useRouteBuilderHeatmapDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderHeatmapDataQuery,
        RouteBuilderHeatmapDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderHeatmapDataQuery,
    RouteBuilderHeatmapDataQueryVariables
  >(RouteBuilderHeatmapDataDocument, options)
}
export type RouteBuilderHeatmapDataQueryHookResult = ReturnType<
  typeof useRouteBuilderHeatmapDataQuery
>
export type RouteBuilderHeatmapDataLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderHeatmapDataLazyQuery
>
export type RouteBuilderHeatmapDataSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderHeatmapDataSuspenseQuery
>
export type RouteBuilderHeatmapDataQueryResult = Apollo.QueryResult<
  RouteBuilderHeatmapDataQuery,
  RouteBuilderHeatmapDataQueryVariables
>
export const RouteBuilderHeatmapFiltersDocument = gql`
    query RouteBuilderHeatmapFilters($metroId: Int!, $heatmapType: HeatmapType!) {
  heatmapFilters(metroId: $metroId, heatmapType: $heatmapType) {
    eventTypes
    initiators
    disengagementReasons
    softwareVersions
    earliestTimestampMs
    latestTimestampMs
  }
}
    `

/**
 * __useRouteBuilderHeatmapFiltersQuery__
 *
 * To run a query within a React component, call `useRouteBuilderHeatmapFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderHeatmapFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderHeatmapFiltersQuery({
 *   variables: {
 *      metroId: // value for 'metroId'
 *      heatmapType: // value for 'heatmapType'
 *   },
 * });
 */
export function useRouteBuilderHeatmapFiltersQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteBuilderHeatmapFiltersQuery,
    RouteBuilderHeatmapFiltersQueryVariables
  > &
    (
      | { variables: RouteBuilderHeatmapFiltersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderHeatmapFiltersQuery,
    RouteBuilderHeatmapFiltersQueryVariables
  >(RouteBuilderHeatmapFiltersDocument, options)
}
export function useRouteBuilderHeatmapFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderHeatmapFiltersQuery,
    RouteBuilderHeatmapFiltersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderHeatmapFiltersQuery,
    RouteBuilderHeatmapFiltersQueryVariables
  >(RouteBuilderHeatmapFiltersDocument, options)
}
// @ts-ignore
export function useRouteBuilderHeatmapFiltersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderHeatmapFiltersQuery,
    RouteBuilderHeatmapFiltersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderHeatmapFiltersQuery,
  RouteBuilderHeatmapFiltersQueryVariables
>
export function useRouteBuilderHeatmapFiltersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderHeatmapFiltersQuery,
        RouteBuilderHeatmapFiltersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderHeatmapFiltersQuery | undefined,
  RouteBuilderHeatmapFiltersQueryVariables
>
export function useRouteBuilderHeatmapFiltersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderHeatmapFiltersQuery,
        RouteBuilderHeatmapFiltersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderHeatmapFiltersQuery,
    RouteBuilderHeatmapFiltersQueryVariables
  >(RouteBuilderHeatmapFiltersDocument, options)
}
export type RouteBuilderHeatmapFiltersQueryHookResult = ReturnType<
  typeof useRouteBuilderHeatmapFiltersQuery
>
export type RouteBuilderHeatmapFiltersLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderHeatmapFiltersLazyQuery
>
export type RouteBuilderHeatmapFiltersSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderHeatmapFiltersSuspenseQuery
>
export type RouteBuilderHeatmapFiltersQueryResult = Apollo.QueryResult<
  RouteBuilderHeatmapFiltersQuery,
  RouteBuilderHeatmapFiltersQueryVariables
>
